import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/client";
import l10n from "../../../l10n/localization";
import ClientForm from "../ClientForm";
import ClientTabs from "../../client/ClientTabs";
import {Button} from "react-materialize";
import * as creationActions from "../../../actions/creation";

class SelectClients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        if(value === 0){
        } else {
            this.props.onChange(value);
        }
    }

    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(ClientForm, {item: null, selectNewItem: true}, creationActions.destroyingnewlyCreatedClient())} icon="add" className="add-button btn-md ml5"/>
                <label className="control-label" htmlFor="root_client">
                    {l10n.fog.client}<i className='right'>{this.props.schema.title}</i>
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_client"
                    value={this.props.formData}
                    options={utils.clientToSelect(this.props.clients)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(ClientTabs, {item: props.value.item}, creationActions.destroyingnewlyCreatedClient())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        clients: state.client.clients,
        loading: state.client.loading
    });
})(SelectClients);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectClients.js